module.exports = __webpack_public_path__ + "static/media/django.711c098d.svg";